import React from "react";
import Radium from "radium";
import moment from "moment-timezone";
import "twix";
import range from "lodash/range";
import uuid from "uuid";
import cloneDeep from "lodash/cloneDeep";
import { darken, lighten } from "material-ui/utils/colorManipulator";

import EventGridRowItem from "./event-grid-row-item.jsx";

import { getColorForTag } from "../../../util";

import { FlatButton } from "material-ui";

const ROW_HEIGHT = 4; // em

class EventGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveredEvent: null,
      date: null,
      dates: [],
      hours: [],
      undatedEvents: [],
      virtualEvents: [],
      longDatedVirtualEvents: {},
      lastDate: null,
      currentGrid: {},
      usedVenues: {}
    };

    this._onClick = this._onClick.bind(this);
    this.renderVirtualItem = this.renderVirtualItem.bind(this);
  }

  static contextTypes = {
    tenant: React.PropTypes.object,
    router: React.PropTypes.object,
    muiTheme: React.PropTypes.object
  };

  _onClick(id) {
    this.context.router.push({
      pathname: `/schedule/${id}`,
      state: { fromSchedule: true }
    });
  }

  componentWillMount() {
    if (this.props.fetchPast) {
      this.props.fetchPast();
    }

    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    let { date, events } = newProps,
      eventsByDate = {},
      longDatedVirtualEvents = {},
      undatedEvents = [],
      virtualEvents = [];

    Object.values(events).forEach(e => {
      if (!e.is_dated) {
        if (e.is_virtual && !e.exclude_from_virtual) {
          virtualEvents.push(e);
        }
      } else {
        e._start_date = e.start_time && moment(e.start_time);
        e._end_date = e.end_time && moment(e.end_time);
        let date = e._start_date.format("YYYY-MM-DD");
        if (!eventsByDate[date]) {
          eventsByDate[date] = [];
        }
        eventsByDate[date].push(e);
      }
    });

    let dates = Object.keys(eventsByDate).sort();

    // date math to know if a long running dated virtual event
    // should show up on any given day of the grid
    Object.values(events).forEach(e => {
      // is this event virtual and dated?
      if (e.is_dated && e.is_virtual) {
        // does this event go longer than a single day?
        const duration = moment.duration(e._end_date.diff(e._start_date));
        if (duration.asHours() > 24) {
          //check the date buttons and if this event falls into it, add it to the list
          dates.forEach(d => {
            if (moment(d).isBetween(e._start_date, e._end_date)) {
              if (!longDatedVirtualEvents[d]) {
                longDatedVirtualEvents[d] = [];
              }
              longDatedVirtualEvents[d].push(e);
            }
          });
        }
      }
    });

    if (!date && !this.state.date) {
      let defaultDate,
        today = moment().format("YYYY-MM-DD");

      if (dates.indexOf(today) !== -1) {
        defaultDate = today;
      } else {
        defaultDate = dates[0];
      }

      this.props.onStateChange({ date: defaultDate });
      this.setState({ date: defaultDate });
      return;
    }

    if (date === "Virtual") {
      if (
        !newProps.appSettings.schedule_include_virtual ||
        virtualEvents.length < 1
      ) {
        date = defaultDate;
      } else {
        eventsByDate["Virtual"] = [];
      }
    }

    if (!eventsByDate[date]) {
      return;
    }

    // SCREENING OVERLAP MANAGEMENT
    let venueList = {};
    let theseEvents = eventsByDate[date];

    theseEvents = theseEvents.map(e => {
      e.display_venue = cloneDeep(e.venue);
      return e;
    });

    // Comparison function for two events to determine if they overlap
    const willTimesOverlap = function (event1, event2) {
      // if one or both events is not defined, return false
      if (!event1 || !event2) {
        return false;
      }
      // check venue, if not the same, return false
      if (event1.display_venue.id !== event2.display_venue.id) {
        return false;
      }

      const event1_startTime = moment(event1._start_date);
      const event1_endTime = moment(event1._end_date);
      const event2_startTime = moment(event2._start_date);
      const event2_endTime = moment(event2._end_date);

      // if start time or end time are the same, they overlap
      if (
        event1_startTime.isSame(event2_startTime) ||
        event1_endTime.isSame(event2_endTime)
      ) {
        return true;
      } else {
        // if start/end times are between the other event, they overlap
        return (
          event1_startTime.isBetween(event2_startTime, event2_endTime) ||
          event1_endTime.isBetween(event2_startTime, event2_endTime) ||
          event2_startTime.isBetween(event1_startTime, event1_endTime) ||
          event2_endTime.isBetween(event1_startTime, event1_endTime)
        );
      }
    };

    theseEvents = theseEvents
      // Ensure consistent ordering so we don't flip spots on refresh
      .sort((a, b) => a.id.localeCompare(b.id))
      .map(e => {
        // Venue needs to be added to all events before overlap check
        if (e.display_venue.id === undefined) {
          if (e.is_virtual) {
            e.display_venue = {
              id: "Virtual",
              name: "Virtual Screening",
              short_name: "Virtual Screening"
            };
          } else {
            e.display_venue = { id: "unknown", name: "Unknown Venue" };
          }
        }

        // save a record of the original id - venue.id could be overwritten
        e.display_venue.original_id = e.display_venue.id.slice();
        // include one initial original_id event in the venueList for each venue
        if (!venueList[e.display_venue.original_id]) {
          venueList[e.display_venue.original_id] = [
            { venueId: e.display_venue.id, event: e }
          ];
        }
        return e;
      });

    // double loop through today's events (z and y) to compare against each other
    for (let z = 0; z < theseEvents.length; z++) {
      // in the case of one event, no comparisons are needed
      if (theseEvents.length === 1) {
        break;
      }

      for (let y = 0; y < theseEvents.length; y++) {
        // if z and y are the same event, continue looping
        if (z === y) {
          continue;
        }
        // if venue is different, continue looping
        if (
          theseEvents[z].display_venue.id !== theseEvents[y].display_venue.id
        ) {
          continue;
        }

        const willOverlap = willTimesOverlap(theseEvents[z], theseEvents[y]);
        if (willOverlap) {
          // look up any other existing venue ids to see if this will fit
          const theseVenueEvents =
            venueList[theseEvents[y].display_venue.original_id];

          let foundTimeSlot = false;
          for (let x = 0; x < theseVenueEvents.length; x++) {
            // if venue ids match, we know these already overlap, break out of loop
            if (
              theseVenueEvents[x].venueId === theseEvents[y].display_venue.id
            ) {
              break;
            } else {
              // found another venue column and event with the same original id
              // check to see if these events overlap
              const alsoOverlapping = willTimesOverlap(
                theseVenueEvents[x].event,
                theseEvents[y]
              );

              // if they don't overlap, there is room in this venue column
              if (!alsoOverlapping) {
                theseEvents[y].display_venue.id = theseVenueEvents[x].venueId;
                foundTimeSlot = true;
                break;
              }
            }
          }

          // if we did not find an available time slot, we need to make
          // a new column for this event
          if (!foundTimeSlot) {
            // create the new unique venue id
            theseEvents[y].display_venue.id =
              theseEvents[y].display_venue.id + "_" + uuid();
            // add this venue/event to the venueList
            venueList[theseEvents[y].display_venue.original_id].push({
              venueId: theseEvents[y].display_venue.id,
              event: theseEvents[y]
            });
          }
        }
      }
    }
    // END SCREENING OVERLAP MANAGEMENT

    let currentGrid = {},
      usedVenues = {},
      lastDate = moment(date),
      maxLastDate = moment(date)
        .add(24 + 3, "hours")
        .subtract(1, "second"); // 3 am is plenty...

    eventsByDate[date].forEach(e => {
      let hour = e._start_date.hours();

      if (!currentGrid[hour]) {
        currentGrid[hour] = {};
      }

      if (!currentGrid[hour][e.display_venue.id]) {
        currentGrid[hour][e.display_venue.id] = [];
      }
      currentGrid[hour][e.display_venue.id].push(e);
      usedVenues[e.display_venue.id] = true;
      if (e._end_date && e._end_date > lastDate) {
        if (e._end_date > maxLastDate) {
          e._end_date = maxLastDate;
        }
        lastDate = e._end_date;
      }
    });

    let hours = Object.keys(currentGrid)
      .map(h => +h)
      .sort((a, b) => a - b);

    if (
      newProps.appSettings.schedule_include_virtual &&
      virtualEvents.length > 0
    ) {
      dates.push("Virtual");
    }

    this.setState({
      dates,
      hours,
      undatedEvents,
      virtualEvents,
      longDatedVirtualEvents,
      lastDate,
      currentGrid,
      usedVenues
    });
  }

  renderVirtualItem(item, key) {
    // This is to remove the time stamp from the List item
    const newItem = cloneDeep(item);
    newItem.is_dated = false;

    let { ListItem, listItemProps, groupItemsB, appSettings } = this.props;

    listItemProps.isLarge = true;
    return (
      <ListItem
        key={key}
        item={newItem}
        compact={true}
        includeDateInCompact={true}
        showExtended={false}
        hideActions={false}
        showBottomBorder={false}
        appSettings={appSettings}
        {...listItemProps}
      />
    );
  }

  getStyles() {
    return {
      root: {
        maxWidth: "95vw",
        margin: "0 auto"
      },
      dateButtonContainer: {
        display: "flex",
        flexWrap: "wrap",
        marginLeft: "-0.5em",
        width: "calc(100% + 1em)",
        marginBottom: "1em",
        justifyContent: "center"
      },
      dateButtonWrapper: {
        margin: "0.5em",
        width: "100%",
        flexBasis: 125,
        maxWidth: 125,
        "@media (man-width: 600px)": {
          maxWidth: "100%",
          flexBasis: "100%"
        }
      },
      dateButton: {
        border: "1px solid",
        width: "100%",
        height: 50
      },
      dateInner: {
        marginTop: -27,
        lineHeight: 1.3,
        fontSize: "10pt"
      },
      dateDay: {
        fontSize: "0.9em"
      },
      table: {
        borderCollapse: "collapse",
        tableLayout: "fixed"
      },
      venueLabel: {
        minWidth: 125,
        fontSize: "1.2em",
        color: "rgba(0,0,0,0.54)"
      },
      virtualLabel: {
        width: "100%",
        fontSize: "1.2em",
        fontWeight: "bold",
        color: "rgba(0,0,0,0.54)",
        textAlign: "center",
        paddingTop: 40
      },
      row: {
        height: `${ROW_HEIGHT}em`,
        maxHeight: `${ROW_HEIGHT}em`,
        overflow: "visible"
      },
      hourLabel: {
        fontSize: "1.2em",
        width: 45,
        minWidth: 45,
        color: "rgba(0,0,0,0.54)",
        verticalAlign: "top",
        position: "relative"
      },
      hourLabelInner: {
        position: "absolute",
        top: "-0.6em",
        width: "90%",
        textAlign: "right"
      },
      eventCell: {
        border: "1px dashed #ccc",
        verticalAlign: "top"
      }
    };
  }

  render() {
    let styles = this.getStyles(),
      {
        dates,
        hours,
        lastDate,
        currentGrid,
        usedVenues,
        virtualEvents,
        undatedEvents
      } = this.state,
      { date, venues } = this.props;

    if (!hours.length && !virtualEvents.length) {
      return null;
    }

    // Add for temporary venue
    venues = venues.concat([
      { id: "unknown", name: "Unknown Venue", original_id: "unknown" }
    ]);
    venues = venues.concat([
      { id: "Virtual", name: "Virtual Screening", original_id: "Virtual" }
    ]);

    const hourKeys = Object.keys(currentGrid);
    hourKeys.map(hk => {
      const venueKeys = Object.keys(currentGrid[hk]);
      venueKeys.map(vk => {
        const venue = venues.find(v => v.id === vk);
        if (!venue) {
          const displayVenue = currentGrid[hk][vk][0].display_venue;
          venues = venues.concat([
            { id: vk, name: displayVenue.short_name || displayVenue.name || "" }
          ]);
        }
      });
    });

    // alphabetize the venues for presentation
    venues.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });

    // Generate all hour rows
    let first =
        hours.length &&
        moment(`${date}T${(hours[0] < 10 ? "0" : "") + hours[0]}:00`),
      delta = first && lastDate.diff(first, "hours"),
      hourRows = hours.length ? range(hours[0], hours[0] + delta + 1) : [];

    // Date buttons
    const isTextInverted =
        this.context.muiTheme.rawTheme.palette.textColor === "#fff",
      buttonColor = this.context.muiTheme.rawTheme.palette.accent1Color,
      buttonTextColor = this.context.tenant.invert_colors
        ? "rgb(33,33,33)"
        : "#fff";

    if (isTextInverted) {
      styles.hourLabel.color = "#fff";
    }

    return (
      <div style={styles.root}>
        <div style={styles.dateButtonContainer}>
          {dates.map(d => {
            const m = moment(d);
            return (
              <div key={d} style={styles.dateButtonWrapper}>
                <FlatButton
                  style={Object.assign(
                    {},
                    styles.dateButton,
                    isTextInverted && { backgroundColor: "#000" },
                    date === d && {
                      backgroundColor: buttonColor,
                      color: buttonTextColor,
                      border: `1px solid ${buttonColor}`
                    }
                  )}
                  labelStyle={{ verticalAlign: 0 }}
                  label={
                    d === "Virtual" ? (
                      <div style={styles.dateInner}>
                        Available
                        <br />
                        Anytime
                      </div>
                    ) : (
                      <div style={styles.dateInner}>
                        <div style={styles.dateDay}>{m.format("dddd")}</div>
                        <div>{m.format("MMM Do")}</div>
                      </div>
                    )
                  }
                  onClick={() => {
                    this.props.onStateChange({ date: d });
                  }}
                />
              </div>
            );
          })}
        </div>
        {this.props.date === "Virtual" ? (
          <div>
            <div key="list">
              {this.state.virtualEvents.map((item, i) =>
                this.renderVirtualItem(item, item.id || uniqueId("rootList"))
              )}
            </div>
          </div>
        ) : (
          <div>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th key="hour" style={styles.hourLabel}></th>
                  {venues
                    .filter(v => usedVenues[v.id])
                    .map(v => {
                      return (
                        <th key={v.id} style={styles.venueLabel}>
                          {v.name}
                        </th>
                      );
                    })}
                </tr>
              </thead>
              <tbody>
                {undatedEvents.length ? (
                  <tr style={styles.row}>
                    <th key="undatedHour" style={styles.hourLabel}>
                      <div style={styles.hourLabelInner}>N/A</div>
                    </th>
                    {venues
                      .filter(v => usedVenues[v.id])
                      .map(venue => {
                        return (
                          <td
                            key={`undated-${venue.id}`}
                            style={styles.eventCell}
                          >
                            {undatedEvents.map(u => {
                              return (
                                <EventGridRowItem
                                  event={u}
                                  rowHeight={ROW_HEIGHT}
                                />
                              );
                            })}
                          </td>
                        );
                      })}
                  </tr>
                ) : null}
                {hourRows.map(hour => {
                  return (
                    <tr key={hour} style={styles.row}>
                      <th style={styles.hourLabel}>
                        <div style={styles.hourLabelInner}>
                          {moment()
                            .hour(hour % 24)
                            .format("ha")}
                        </div>
                      </th>
                      {venues
                        .filter(v => usedVenues[v.id])
                        .map(venue => {
                          return (
                            <td key={venue.id} style={styles.eventCell}>
                              {(
                                (currentGrid[hour] &&
                                  currentGrid[hour][venue.id]) ||
                                []
                              )
                                .sort((a, b) =>
                                  a.start_time.localeCompare(b.start_time)
                                )
                                .map(e => {
                                  return (
                                    <EventGridRowItem
                                      event={e}
                                      rowHeight={ROW_HEIGHT}
                                    />
                                  );
                                })}
                            </td>
                          );
                        })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div>
              <div key="list-v" style={{ paddingLeft: 45 }}>
                {this.state.longDatedVirtualEvents[this.props.date] ? (
                  <div>
                    <div style={styles.virtualLabel}>
                      Virtual screenings (available{" "}
                      {moment(this.props.date).format("MMM D")})
                    </div>
                    {this.state.longDatedVirtualEvents[this.props.date].map(
                      (item, i) => {
                        return this.renderVirtualItem(
                          item,
                          item.id || uniqueId("rootList")
                        );
                      }
                    )}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Radium(EventGrid);



// WEBPACK FOOTER //
// ./src/app/components/partials/event-list/event-grid.jsx